export default "__VITE_ASSET__cf542bde__"